/**
 * PineScript adapter — public interface for the Pro pinescript module.
 *
 * Stays in public widget. widget-pro implements this interface and registers
 * via setPineScriptAdapter(). Public consumers call getPineScriptAdapter()
 * and skip gracefully when null (Pro module not loaded).
 *
 * Type-only: no imports from modules that will move to widget-pro.
 * This file must never import ./compile, ./pineStrategy, etc.
 */
let _adapter = null;
export function setPineScriptAdapter(a) {
    _adapter = a;
}
export function getPineScriptAdapter() {
    return _adapter;
}
export function hasPineScriptAdapter() {
    return _adapter !== null;
}
